import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/website.jpg'
import _imports_1 from '../assets/vimeo.jpg'
import _imports_2 from '../assets/hikaku.jpg'
import _imports_3 from '../assets/trial-banner.jpg'
import _imports_4 from '../assets/catalog-banner.jpg'
import _imports_5 from '../assets/contact-banner.jpg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar navbar-lg bg-secondary-subtle\"><div class=\"mx-4\"><a class=\"navbar-brand\" href=\"#\"><img src=\"https://storage.googleapis.com/zettasuite_gcs01/converter/img/suite_converter.png\" height=\"40\" alt=\"Logo\" class=\"d-inline-block align-text-mid\"><span class=\"navbar-brand mb-0 h1\"> Suiteコンバーター</span><span class=\"navbar-brand mb-0\">Jamboard 版</span></a></div></nav>", 1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"p-4 mt-4\"><h1 class=\"text-center p-4\">Jamboard ファイル　→　Google スライド</h1><p class=\"text-start lh-base bg-light p-5\"> ● 本ツールは、Google Jamboard のファイル を Suiteシリーズの「ふせん」機能に対応した Google スライド のファイルに変換するツールです。<br>● 本ツールのご利用に際しては、ご利用規約をお読みいただいたうえで本規約に同意していただき、Google ID でサインインしてご利用ください。<br>※ 同意のチェックボックスにチェックを入れてもサインインボタン が表示されない場合は、ブラウザの再読み込みを行い、再度規約に同意していただくことで表示されます。<br> ※ 児童生徒端末など18歳未満の設定が行われているユーザーに対しては、<a href=\"https://docs.google.com/document/d/e/2PACX-1vRL-r2voa3OuT5UXXXIItoAAdPlQfG0m1uWMgYcDXUQsF9nVHNnoLfJUTRPpHcD9j85K6SodbrK5zDY/pub\" target=\"_new\">管理コンソールよりサードパーティ製アプリのアクセスを許可</a>する必要があります。<br>● 変換されたファイルは Google スライド で開いて編集することが出来ます。<br>● Suiteシリーズのふせん機能を利用する事で Jamboard のような操作性で、デジタルふせんを使った学習を継続することができます。 <br><span class=\"text-start text-danger\"> ● 本ツールは2024年12月31日の Google Jamborad サービス終了に合わせて利用出来なくなります。 </span></p></div>", 1)
const _hoisted_5 = { class: "d-grid gap-2 col-md-4 mx-auto mt-4 mb-4" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "agreePrivacy",
  class: "ps-2"
}, "Suiteコンバーター利用規約を確認し、同意します。 ", -1)
const _hoisted_8 = {
  key: 0,
  class: "d-grid gap-2 col-6 mx-auto mt-4",
  id: "authorize_button"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.google.com/document/d/e/2PACX-1vRL-r2voa3OuT5UXXXIItoAAdPlQfG0m1uWMgYcDXUQsF9nVHNnoLfJUTRPpHcD9j85K6SodbrK5zDY/pub",
    target: "_new",
    class: "small u text-primary"
  }, "サインインに関する問題を解決する方法についてはこちら")
], -1)
const _hoisted_10 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-share-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" })
], -1)
const _hoisted_12 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-question-circle-fill me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "m-5" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "text-end mt-1" }
const _hoisted_18 = { class: "p-4 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center p-4" }, "Jamboard ファイル　→　Google スライド", -1)
const _hoisted_20 = { class: "d-grid gap-2 col-md-4 mx-auto mt-4" }
const _hoisted_21 = { class: "p-4" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<h4 class=\"mt-4\">使い方</h4><ol class=\"list-group list-group-numbered mb-4\"><li class=\"list-group-item\"> [ Jamboard のファイルを選択する ]ボタンをクリックし、変換する Jamboard ファイルを選択します。<br><br> 　※ファイルの選択一覧は最近開いたJamboardファイルの順番で表示されます。 <br> 　事前に対象のJamboardファイルを開くか、検索して一覧に表示させてください。 </li><li class=\"list-group-item\"> 変換されたスライドファイルは、Google ドライブのマイドライブに保存されます。（上書き保存されません）<br><br> 　※Jamboard の付箋の色は、Suiteシリーズのふせんの色に変換されます。（<a href=\"#taiou\">対応表</a>） </li></ol>", 2)
const _hoisted_24 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-share-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" })
], -1)
const _hoisted_26 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-question-circle-fill me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<hr class=\"mt-4\"><h6 class=\"mt-4\">変換されない要素</h6><ul class=\"list-group list-group-flush\"><li class=\"list-group-item list-group-item-info\">ペン</li><li class=\"list-group-item list-group-item-info\">図形、円、半円、三角形、ひし形、矢印</li><li class=\"list-group-item list-group-item-info\">画像以外の背景</li></ul><h6 class=\"mt-4\">制限事項</h6><ul class=\"list-group list-group-flush\"><li class=\"list-group-item list-group-item-warning\">回転には対応していません。</li><li class=\"list-group-item list-group-item-warning\"> 背景画像はページサイズにフィットされます。 </li></ul>", 5)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"m-4\"><h6 id=\"taiou\">ふせんの色変換：対応表</h6><div class=\"col-md-4\"><table class=\"table table-borderless col-md-4\"><thead><tr><th scope=\"col\" style=\"width:200px;\">Jamboard</th><th scope=\"col\"></th><th scope=\"col\" style=\"width:200px;\">Suiteシリーズ</th></tr></thead><tbody><tr><td style=\"background-color:#ffeb3b;\">黄</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#ffd966;\">黄</td></tr><tr><td style=\"background-color:#aeea00;\">緑</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#85e0a3;\">緑</td></tr><tr><td style=\"background-color:#80deea;\">青</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#80caff;\">青</td></tr><tr><td style=\"background-color:#ff80ab;\">ピンク</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#ffbdf2;\">ピンク</td></tr><tr><td style=\"background-color:#ff9e00;\">オレンジ</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#ffc470;\">オレンジ</td></tr><tr><td style=\"border:solid 1px #ccc;\">透明</td><td style=\"background-color:#fff;\" class=\"text-center\">→</td><td style=\"background-color:#e6e6e6;\">薄い灰色</td></tr></tbody></table></div></div><hr class=\"m-5\">", 2)
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<footer class=\"mt-auto py-4\"><div class=\"container text-center\"><div class=\"row align-items-start\"><div class=\"col-md-4\"><div class=\"card m-3 p-0\"><img src=\"" + _imports_0 + "\" class=\"card-img-top\" alt=\"製品サイト\"><div class=\"card-body\"><h5 class=\"card-title\">製品サイト</h5><p class=\"card-text\"> Suiteツール、こどもSuite、まなびSuite、SuiteモニターなどのSuiteシリーズ製品をご紹介 </p><a href=\"https://www.kodomo-suite.jp/\" class=\"btn btn-dark\" target=\"_new\">製品サイト</a></div></div></div><div class=\"col-md-4\"><div class=\"card m-3 p-0\"><img src=\"" + _imports_1 + "\" class=\"card-img-top\" alt=\"動画でわかるSuiteツール\"><div class=\"card-body\"><h5 class=\"card-title\">動画でわかるSuiteツール</h5><p class=\"card-text\"> ふせん・ふせん集計、縦書き・ルビ、数式エディタなどの機能を動画でわかりやすくご紹介 </p><a href=\"https://vimeo.com/showcase/10616259\" class=\"btn btn-dark\" target=\"_new\">動画サイト（Vimeo）</a></div></div></div><div class=\"col-md-4\"><div class=\"card m-3 p-0\"><img src=\"" + _imports_2 + "\" class=\"card-img-top\" alt=\"協働学習ツール比較\"><div class=\"card-body\"><h5 class=\"card-title\">協働学習ツールの比較</h5><p class=\"card-text\"> Jamboard、FigJam、Google スライド（Suiteツール）の機能比較をご紹介 </p><a href=\"https://www.kodomo-suite.jp/hikaku\" class=\"btn btn-dark\" target=\"_new\">機能比較</a></div></div></div></div></div><div class=\"container text-center\"><div class=\"row align-items-start\"><div class=\"col-md-4\"><a href=\"https://workspace.google.com/marketplace/app/suite%E3%83%84%E3%83%BC%E3%83%AB/219916649275?pann=b\" class=\"image_link p-5\" target=\"_new\"><img src=\"" + _imports_3 + "\" class=\"card-img-top\" alt=\"30日間無料トライアル\"></a></div><div class=\"col-md-4\"><a href=\"https://www.zettalinx.co.jp/contact/info-request/\" class=\"image_link p-5\" target=\"_new\"><img src=\"" + _imports_4 + "\" class=\"card-img-top\" alt=\"資料請求\"></a></div><div class=\"col-md-4\"><a href=\"https://www.zettalinx.co.jp/contact/inquiry/\" class=\"image_link p-5\" target=\"_new\"><img src=\"" + _imports_5 + "\" class=\"card-img-top\" alt=\"お問い合わせ\"></a></div></div></div><div class=\"text-center py-4\" style=\"background-color:#5c5f62;\"><div class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover\"><h6>Suiteツール／Suiteツール for Education</h6><p class=\"small\"><a target=\"_blank\" href=\"https://www.kodomo-suite.jp/privacy\" class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover\">プライバシーポリシー</a><span> | </span><a target=\"_blank\" href=\"https://www.kodomo-suite.jp/policy\" class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover\">サイトポリシー</a><span> | </span><a target=\"_blank\" href=\"https://www.kodomo-suite.jp/privacy_en\" class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover\">Privacy Policy</a><span> | </span><a class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover\" target=\"_blank\" href=\"https://www.kodomo-suite.jp/appPolicy_en\">Application Policy</a></p></div><div><a class=\"link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover small\" target=\"_blank\" href=\"https://www.zettalinx.co.jp/\">© 2011-2024 ゼッタリンクス株式会社</a></div></div></footer>", 1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "Jamboardを読み込んでいます。", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, "Jamboardを読み込みました。", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, "ファイルの変換を行っています。", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", null, "●変換対象", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, "●変換非対応", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "変換が完了しました。", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, "マイドライブにスライドファイルが作成されました。", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalMsg = _resolveComponent("ModalMsg")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.bToken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.urlOpen(
              'https://docs.google.com/document/d/e/2PACX-1vS2E1sZg3QLS17UdXHJQnd4h0x6weY079B4t1t59RgkwugQWLZ4uIJa7kXyoFYEv3jGvE7W-s2oR3l_/pub'
            )
          ))
              }, " Suiteコンバーター利用規約 ")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "agreePrivacy",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bChkPolicy) = $event)),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.PolicyChk && _ctx.PolicyChk(...args)))
              }, null, 512), [
                [_vModelCheckbox, _ctx.bChkPolicy]
              ]),
              _hoisted_7
            ]),
            (_ctx.bAgree)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.bLogin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                        class: "login-btn mx-auto",
                        id: "loginBtn"
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-outline-dark me-md-2 share btn-sm",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openShare && _ctx.openShare(...args)))
              }, [
                _hoisted_11,
                _createTextVNode(" 　Jamboardコンバーターをシェアする ")
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-outline-dark me-md-2 btn-sm",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.urlOpen('https://forms.gle/pLrRGyBxJxpQEJ5u8'))),
                target: "_new"
              }, [
                _hoisted_13,
                _createTextVNode(" 製品のお問い合わせや、一括変換などのご相談はこちら ")
              ])
            ]),
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.bToken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("section", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, "ログアウト")
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  id: "signout_button",
                  class: "btn btn-primary btn-lg",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createPicker && _ctx.createPicker(...args)))
                }, " Jamboard のファイルを選択する ")
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "btn btn-outline-dark me-md-2 share btn-sm",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openShare && _ctx.openShare(...args)))
                }, [
                  _hoisted_25,
                  _createTextVNode(" 　Jamboardコンバーターをシェアする ")
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  class: "btn btn-outline-dark me-md-2 btn-sm",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.urlOpen('https://forms.gle/pLrRGyBxJxpQEJ5u8'))),
                  target: "_new"
                }, [
                  _hoisted_27,
                  _createTextVNode(" 製品のお問い合わせや、一括変換などのご相談はこちら ")
                ])
              ]),
              _hoisted_28
            ]),
            _hoisted_33
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_35,
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.status == 'initializing')
        ? (_openBlock(), _createBlock(_component_ModalMsg, {
            key: 0,
            title: "読み込み中..."
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.status == 'running')
        ? (_openBlock(), _createBlock(_component_ModalMsg, {
            key: 0,
            title: "作成中..."
          }, {
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _createElementVNode("div", null, "・ふせん：" + _toDisplayString(_ctx.nPostit) + "/" + _toDisplayString(_ctx.nPostit_Total) + " 個", 1),
              _createElementVNode("div", null, "・画像：" + _toDisplayString(_ctx.nImage) + "/" + _toDisplayString(_ctx.nImage_Total) + " 個", 1),
              _createElementVNode("div", null, "・ラべル：" + _toDisplayString(_ctx.nLabel) + "/" + _toDisplayString(_ctx.nLabel_Total) + " 個", 1),
              _createElementVNode("div", null, "・図形：" + _toDisplayString(_ctx.nShape) + "/" + _toDisplayString(_ctx.nShape_Total) + " 個", 1),
              _hoisted_40,
              _createElementVNode("div", null, "・図形：" + _toDisplayString(_ctx.nShape_N) + " 個", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.status == 'success')
        ? (_openBlock(), _createBlock(_component_ModalMsg, {
            key: 0,
            title: "完了"
          }, {
            default: _withCtx(() => [
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  onClick: _ctx.openResult,
                  type: "fill",
                  class: "btn btn-primary btn-lg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("スライドを開く")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _hoisted_44,
                _hoisted_45,
                _createVNode(_component_Button, {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.status = 'nothing')),
                  type: "line",
                  class: "btn btn-primary btn-lg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("閉じる")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}